import { FileText, Sparkles } from 'lucide-react';
import LectureAiChip from './LectureAiChip';
import { Card, CardContent } from '../ui/card';

export default function NormalizedSourceCard({ document }) {
  const normalization = document?.normalization || {};
  const outline = normalization.outline || [];
  const statusLabel = document.normalization_status === 'ready'
    ? 'Normalized for AI'
    : document.normalization_status === 'processing'
      ? 'Processing in background'
      : normalization.error
        ? 'Needs attention'
        : 'Awaiting normalization';

  return (
    <Card className="border-border/60 bg-card/70 shadow-card transition-[transform,box-shadow] duration-200 ease-out motion-reduce:transition-none hover:-translate-y-[1px] hover:shadow-sm">
      <CardContent className="space-y-4 p-5">
        <div className="flex flex-wrap items-center gap-2">
          <LectureAiChip icon={FileText} label={document.title} tone="document" className="max-w-full" />
          <LectureAiChip icon={Sparkles} label={statusLabel} tone="tool" />
        </div>
        <p className="text-sm leading-6 text-muted-foreground">
          {normalization.error
            ? normalization.error
            : normalization.strategy === 'canonical_markdown'
            ? 'This source has been converted into a canonical markdown context for stronger model understanding.'
            : document.normalization_status === 'processing'
              ? 'Your upload is complete. Document parsing and indexing are still running in the background.'
              : 'This source is stored, but it has not been normalized yet.'}
        </p>
        {outline.length ? (
          <div className="space-y-2">
            {outline.slice(0, 4).map((item) => (
              <div key={item} className="text-sm text-foreground/80">{item}</div>
            ))}
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
